const SYSTEM_SEARCH_TERMS = {
  wear: 'wear rotation',
  sell: 'sell resale',
  workwear: 'work clothes workwear office',
  worn: 'worn used',
  laundry: 'laundry wash washing',
  clean: 'clean ready',
};

const SURROUNDING_SEARCH_TERMS = {
  garden: 'garden outdoors outdoor plant plants watering',
  library: 'library books book reading media',
  storage: 'storage drawer drawers seasonal long term',
  pantry: 'pantry groceries grocery food dry goods',
  care: 'care instructions manual label warranty',
  objects: 'objects decor decoration useful',
};

export function itemSearchText(item = {}) {
  const details = Object.values(item.details || {}).join(' ');
  const tags = Array.isArray(item.tags) ? item.tags.join(' ') : '';
  const surrounding = item.surrounding || {};
  const surroundingText = [
    surrounding.branch,
    surrounding.kind,
    surrounding.status,
    surrounding.nextAction,
    surrounding.infoText,
    surrounding.notes,
    surrounding.care,
    surrounding.readingStatus,
    surrounding.storageTerm,
    surrounding.storageSeason,
    surrounding.nextActionAt,
    surrounding.reviewAt,
    surrounding.expiryDate,
    surrounding.openedAt,
    SURROUNDING_SEARCH_TERMS[surrounding.branch] || '',
  ].filter(Boolean).join(' ');
  const status = item.wearStatus || 'clean';
  return [
    item.label,
    details,
    tags,
    item.ocrText,
    item.genre,
    item.category,
    item.type,
    item.details?.profileType,
    item.location?.name,
    item.location?.type,
    item.zone?.name,
    surroundingText,
    item.intent?.wear ? SYSTEM_SEARCH_TERMS.wear : '',
    item.intent?.sell ? SYSTEM_SEARCH_TERMS.sell : '',
    item.workwear ? SYSTEM_SEARCH_TERMS.workwear : '',
    SYSTEM_SEARCH_TERMS[status] || status,
  ].filter(Boolean).join(' ').toLowerCase();
}

export function normalizeSearchQuery(value) {
  return String(value || '').trim().toLowerCase();
}

export function getWardrobeTags(items = []) {
  return [...new Set(items.flatMap(item => Array.isArray(item.tags) ? item.tags : []).map(tag => String(tag).trim()).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

export function itemHasTag(item, tag) {
  if (!tag) return true;
  return (item.tags || []).some(value => String(value).toLowerCase() === String(tag).toLowerCase());
}

export function matchesSearchText(text, query) {
  const tokens = normalizeSearchQuery(query).split(/\s+/).filter(Boolean);
  const haystack = String(text || '').toLowerCase();
  return tokens.every(token => haystack.includes(token));
}

export function matchesItemSearch(item, query, tag = '') {
  return matchesSearchText(itemSearchText(item), query) && itemHasTag(item, tag);
}
